import {minutesToMilliseconds} from 'date-fns';

export const pollingConfig = {
  pollIntervalInMs: 5000,
  allowedRunTimeInMs: minutesToMilliseconds(3),
}
export const allowedConcurrentRequests = 50